import { type SWRConfiguration } from 'swr';
import useSWR from 'swr';
import denApi from '@/lib/api/denApi';
import { type ProposalWithSignatures } from './use-account-proposals';

type AccountProposalsData = {
  proposals: ProposalWithSignatures[];
};

const accountProposalsFetcher = async (
  url: string
): Promise<AccountProposalsData> =>
  await denApi.get<AccountProposalsData, void>(url);

/**
 * Hook wrapper for account proposals that matches the signature expected by PendingSignaturesModal
 */
export function usePendingAccountProposalsForPolling(
  swrOptions?: SWRConfiguration<AccountProposalsData>
): void {
  const url = 'multichain-account/proposals';
  useSWR<AccountProposalsData>(url, accountProposalsFetcher, {
    revalidateOnFocus: false,
    ...(swrOptions ?? {}),
  });
}
